module.exports = {
	publicPath: "/the-cycle/",

	chainWebpack: (config) => {
		config.plugin("html").tap((args) => {
			args[0].title = "TC:F | Interactive Map"
			return args
		})
	},

	pluginOptions: {
		i18n: {
			locale: "en",
			fallbackLocale: "en",
			localeDir: "locales",
			enableLegacy: false,
			runtimeOnly: false,
			compositionOnly: false,
			fullInstall: true,
		},
	},
}
